import { defineStore } from "pinia";
import { reactive } from "vue";

import { TFeatureFlag } from "../launch-darkly/main";

export const useLaunchDarklyStore = defineStore("launchDarkly", () => {
  const ldFlags = reactive({
    flags: {} as Record<TFeatureFlag, boolean>,
  });

  function setFlags(flags: Record<TFeatureFlag, boolean>) {
    ldFlags.flags = flags;
  }

  return { ldFlags, setFlags };
});
